var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppsLabelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.01358,
    y: 2.00195,
    width: 6,
    height: 6,
    className: "iconStroke",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.01358,
    y: 12.002,
    width: 6,
    height: 6,
    className: "iconStroke",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0136,
    y: 2.00195,
    width: 6,
    height: 6,
    className: "iconStroke",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0136 19.0039V11.0039",
    className: "iconStroke",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0098 15.002H10.0098",
    className: "iconStroke",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsLabelIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS4wMTM1OCIgeT0iMi4wMDE5NSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgY2xhc3M9Imljb25TdHJva2UiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxLjAxMzU4IiB5PSIxMi4wMDIiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIGNsYXNzPSJpY29uU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMTEuMDEzNiIgeT0iMi4wMDE5NSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgY2xhc3M9Imljb25TdHJva2UiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTQuMDEzNiAxOS4wMDM5VjExLjAwMzkiIGNsYXNzPSJpY29uU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE4LjAwOTggMTUuMDAySDEwLjAwOTgiIGNsYXNzPSJpY29uU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };